module.exports = __webpack_public_path__ + "img/GeneralConsentIcon.3d9d882a.svg";